import { Box } from '@chakra-ui/react';
import { useTheme } from '@time-line/components/theme';
import type { ReactNode } from 'react';

interface ContainerProps {
  children: ReactNode;
}

export function SectionHeaderContainer({ children }: ContainerProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        '> .chakra-text': {
          ...theme.components.Text.sizes.body2,
        },
      }}
    >
      {children}
    </Box>
  );
}
